import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AbcNoDataFound from "../alert/AbcNoDataFound.vue";
import cloneDeep from "lodash/cloneDeep";

@Component({
    components: {
        AbcNoDataFound
    },
    directives: {
        scroll: {
            inserted(el, binding) {
                if (binding.value) {
                    el.scrollIntoView({ block: "nearest" });
                }
            },
            componentUpdated(el, binding) {
                if (binding.value) {
                    el.scrollIntoView({ block: "nearest" });
                }
            }
        }
    }
})
export default class WithItemsMixin extends Vue {
    @Prop({ required: true }) items!: unknown[] | null;
    @Prop() itemId!: string | null;
    @Prop() selectedItem!: unknown | unknown[];
    @Prop({ default: "hover:bg-bg-500" }) followMouse!: string;
    @Prop({ type: Boolean }) readonly hideNoData !: boolean;
    @Prop() disabledItems!: unknown[];
    @Prop({ default: "" }) disabledTooltip!: string;

    curIndex = -1;
    clickedItem: number | null = null;
    previousSelected: any[] = [];
    lastSelected = -1;

    mounted() {
        if (!this.items) {
            return;
        }
        if (Array.isArray(this.selectedItem) && this.selectedItem.length) {
            const position = (this.selectedItem as any[]).length - 1;
            this.previousSelected = cloneDeep(this.selectedItem);
            this.lastSelected = this.items.findIndex(it => this.isEqual(it, (this.selectedItem as any)[position]));
        } else {
            const index = this.items.findIndex(it => this.isEqual(it, this.selectedItem));
            this.lastSelected = index;
            this.curIndex = index;
        }
    }

    protected isItemDisabled(item: unknown) {
        return this.disabledItems?.some(it => this.isEqual(it, item));
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    protected itemKey(item: any, i: number) {
        if (!this.itemId) {
            return i;
        }
        return item[this.itemId];
    }

    @Watch("selectedItem")
    onSelectedItem() {
        let onlyNew: any;
        if (Array.isArray(this.selectedItem)) {
            // compute diff of new values
            onlyNew = this.selectedItem.filter((nv: any) => !this.previousSelected.some((ov: any) => this.isEqual(ov, nv)));
            this.previousSelected = cloneDeep(this.selectedItem);
        } else {
            onlyNew = [this.selectedItem];
        }
        // assign lastSelected to last in the list of newly added
        let index = -1
        if (this.items) {
            index = this.items.findIndex(it => this.isEqual(it, onlyNew[onlyNew.length - 1]));
        }
        this.lastSelected = index;
        this.curIndex = index;
    }

    protected isEqual(a: any, b: any) {
        if (this.itemId && !!a && !!b) {
            return a[this.itemId] === b[this.itemId]
        }
        return a === b;
    }

    handleKey(e: KeyboardEvent) {
        if (!this.items) {
            return;
        }
        switch (e.key) {
            case "ArrowDown":
                if (this.curIndex < this.items.length - 1) {
                    this.curIndex++;
                }
                break;
            case "ArrowUp":
                if (this.curIndex > 0) {
                    this.curIndex--;
                }
                break;
            case "Enter":
                this.clickedItem = this.curIndex;
                break;
        }
    }
}

